import CardTableSwitch from './CardTableSwitch'

export default CardTableSwitch
